module.exports = __webpack_public_path__ + "img/6m3.847ce645.jpg";